const mapFormValue = (target, object) => {
  let fields = Object.keys(target)
  Object.assign(
    target,
    Object.keys(object)
      .filter((key) => fields.includes(key))
      .reduce((carry, key) => {
        carry[key] = object[key]
        return carry
      }, {})
  )
}

export {
  mapFormValue,
}
